// LEGACY — superseded by features/client-rental-config/. Scheduled for deletion in 2 sprints.
import { APIClient } from "../../../helpers/api_helper";
import * as url from "../../../helpers/url_helper";

const api = new APIClient();

// Get client rental config by client ID
// API: GET /api/v1/ClientRentalConfiguration/client/{clientId}
export const getClientRentalConfigByClientId = (clientId: string | number) => {
  return api.get(`${url.CLIENT_RENTAL_CONFIG}/client/${clientId}`);
};

// Create client rental config
// API: POST /api/v1/ClientRentalConfiguration
export const createClientRentalConfig = (data: any) => {
  return api.create(url.CLIENT_RENTAL_CONFIG, data);
};

// Update client rental config
// API: PUT /api/v1/ClientRentalConfiguration/{id}
export const updateClientRentalConfig = (id: string | number, data: any) => {
  return api.put(`${url.CLIENT_RENTAL_CONFIG}/${id}`, data);
};